// Valor do plano conforme a forma de pagamento: `valor` = débito automático; `valor_boleto` (Empresarial) = boleto
const KEYS = ['tv', 'internet', 'fixo', 'movel', 'alacarte', 'pontosextra', 'pontosadicionais'];

export const valorPorPagamento = (plano, forma) =>
  (forma === 'Boleto' && plano?.valor_boleto != null ? Number(plano.valor_boleto) : Number(plano?.valor)) || 0;

export const temValorBoleto = (plano) => plano?.valor_boleto != null && Math.abs(Number(plano.valor_boleto) - Number(plano.valor)) > 0.009;

const fmt = (v) => `R$ ${(Number(v) || 0).toFixed(2)}`;
export const labelPlano = (plano, forma) =>
  `${plano.nome_plano} (${fmt(valorPorPagamento(plano, forma))}${temValorBoleto(plano) ? (forma === 'Boleto' ? ' boleto' : ' débito') : ''})`;

// Patch do formulário ao trocar a forma de pagamento: recalcula os valores dos planos escolhidos na tabela de Valores
export const aplicarFormaPagamento = (d, forma, planosDisponiveis) => {
  const porId = new Map((planosDisponiveis || []).map((p) => [p.id, p]));
  const patch = { pagamento: { ...(d.pagamento || {}), forma_pagamento: forma } };
  let alterados = 0;
  KEYS.forEach((key) => {
    const p = porId.get(d[`plano_${key}_id`]);
    if (!p) return;
    const novo = valorPorPagamento(p, forma);
    if (Math.abs(novo - (Number(d[`plano_${key}_valor`]) || 0)) > 0.009) alterados += 1;
    patch[`plano_${key}_valor`] = novo;
  });
  if (d.internets_adicionais?.length) {
    patch.internets_adicionais = d.internets_adicionais.map((i) => {
      const p = porId.get(i.plano_id);
      if (!p) return i;
      const novo = valorPorPagamento(p, forma);
      if (Math.abs(novo - (Number(i.valor) || 0)) > 0.009) alterados += 1;
      return { ...i, valor: novo };
    });
  }
  return { patch, alterados };
};
